import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Text } from '@fragments';
import { IconLogin } from '@tabler/icons-react';
import { STUDIO_AUTOMATIONS_CONNECT, STUDIO_AUTOMATIONS_LIST, STUDIO_AUTOMATIONS_TRASH } from '../../enums/routes';
import ConnectHero from './components/ConnectHero';
import PageState from './components/PageState';
import Connect from './pages/Connect';
import Overview from './pages/Overview';
import List from './pages/List';
import Editor from './pages/Editor';
import Detail from './pages/Detail';
import './styles.scss';

// /studio/automations — DM automations (ClickUp 868mgytd3, contract 2.14.0): the home, the list and
// its trash, the channel connection, and one automation's results and editor. Scrolls inside the
// shell, under the header's blur.
export default function Automations({ studio: s }) {
  const { t } = useTranslation('studioAutomations');
  const { pathname } = s.location;
  const id = pathname.match(/^\/studio\/automations\/(sau-[^/]+)/)?.[1];
  const page = !s.auth.signed ? <PageState icon={<IconLogin />} text={t('signIn')} action={<Button variant="rounded" color="inverse" onClick={s.goToLogin}>{t('studio:login')}</Button>} />
    : s.accountStatus === 'loading' ? <PageState><Text.h4 loading>{t('title')}</Text.h4></PageState>
    : !s.profile ? <ConnectHero studio={s} variant="profile" />
    : pathname === STUDIO_AUTOMATIONS_CONNECT ? <Connect studio={s} />
    : pathname === STUDIO_AUTOMATIONS_LIST ? <List key="list" studio={s} />
    : pathname === STUDIO_AUTOMATIONS_TRASH ? <List key="trash" studio={s} trashed />
    : id && pathname.endsWith('/edit') ? <Editor key={`${id}-${s.profile.id}`} studio={s} id={id} />
    : id ? <Detail key={`${id}-${s.profile.id}`} studio={s} id={id} />
    : <Overview key={s.profile.id} studio={s} />;
  return <div className="studio-automations">{page}</div>;
}
